export let Modals = /*#__PURE__*/function (Modals) {
  Modals["none"] = "none";
  Modals["error"] = "error";
  Modals["loading"] = "loading";
  Modals["installingLoader"] = "installingLoader";
  Modals["goToOtherTab"] = "goToOtherTab";
  Modals["userConsent"] = "userConsent";
  Modals["siteSelector"] = "siteSelector";
  Modals["upgradeToPremium"] = "upgradeToPremium";
  Modals["connectDomain"] = "connectDomain";
  Modals["businessFirst"] = "businessFirst";
  Modals["devModeSiteSelector"] = "devModeSiteSelector";
  return Modals;
}({});
//# sourceMappingURL=types.js.map